import { render, staticRenderFns } from "./OnboardingIDPage.vue?vue&type=template&id=64f694bc&scoped=true&"
import script from "./OnboardingIDPage.vue?vue&type=script&lang=js&"
export * from "./OnboardingIDPage.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingIDPage.vue?vue&type=style&index=0&id=64f694bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f694bc",
  null
  
)

export default component.exports